export default __webpack_public_path__ + "static/media/BCStout.4f804767.webp";